export default {
  type: 'user_tags',
  relationships: {
    training_class: { type: 'training_class' },
    training_classes: { type: 'training_classes' },
  },
};
